import { Component } from 'react';
import NavigationTabLinks from '../containers/navigationTabLinks';
import {WebCache} from "../../services/WebCache";

class NavigationTabLinksForTransactions extends Component {
    
    generateNavLinks(){
        let urlArray= WebCache.isUserUYU() ? [
            {to: '/sales/transactions', icon: 'fe fe-credit-card', label: 'transactionReport'},
            {to: '/sales/pendingOrders', icon: 'fe fe-calendar', label: 'pendingOrders'},
        ] : 
        [
            {to: '/sales/transactions', icon: 'fe fe-credit-card', label: 'transactionReport'}
        ]

        if(!WebCache.isUserUYU() && WebCache.getAllWholesalerMerchants(false).length>0) // si contiene comercios asociados y es de argentina, estara disponible esta seccion
            urlArray.push({ to: '/sales/minTransactions', icon: 'fe fe-calendar', label: 'minTransactions'})

        return urlArray;
    }

    render() {
        return (
            <NavigationTabLinks
                items= {this.generateNavLinks()}
            ></NavigationTabLinks> 
        )
    };
}

export default NavigationTabLinksForTransactions;
